var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c(
        "section",
        { attrs: { id: "information" } },
        [
          _vm.hasAccount
            ? [
                _c(
                  "button",
                  {
                    staticClass:
                      "link float-right margin-0 padding-y-4xs padding-x-0",
                    attrs: {
                      "aria-label": "Sign out of this account",
                      "data-balloon-pos": "left",
                    },
                    on: { click: _vm.beginSignOut },
                  },
                  [_vm._v("\n        Sign Out\n      ")]
                ),
                _vm._v(" "),
                _c("dl", { staticStyle: { "--padding-left": "0" } }, [
                  _c("dt", { staticClass: "sr-only" }, [
                    _vm._v("Current Account"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    {
                      staticStyle: {
                        "font-weight": "var(--font-weight-semibold)",
                      },
                    },
                    [
                      _vm.hasExistingName
                        ? _c(
                            "span",
                            { staticClass: "display-block margin-bottom-4xs" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.existingFirstName) +
                                  " " +
                                  _vm._s(_vm.existingLastName) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "size-lg" }, [
                        _vm._v(_vm._s(_vm.existingEmail)),
                      ]),
                    ]
                  ),
                ]),
              ]
            : [
                _vm.isShowingEmailExistsNotice
                  ? _c(
                      "wa-message",
                      {
                        attrs: {
                          theme: "blue",
                          title: "You've already got an account!",
                          type: "flash",
                        },
                      },
                      [
                        _c(
                          "p",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c(
                              "site-link",
                              {
                                attrs: { to: { name: "sessions.sign-in" } },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "sign_in_button_click",
                                      { context: "purchase_form" }
                                    )
                                  },
                                },
                              },
                              [_vm._v("Sign in")]
                            ),
                            _vm._v(
                              "\n          to continue or perhaps you need to use a different email address?\n        "
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$invalid({ after: "payment", topics: ["email"] })
                  ? _c("wa-message", {
                      attrs: {
                        theme: "danger",
                        content: "Email address is not valid",
                        type: "flash",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "site-link",
                  {
                    staticClass: "secondary float-right",
                    attrs: {
                      to: {
                        name: "sessions.sign-in",
                        query: { next: _vm.$route.path },
                      },
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("sign_in_button_click", {
                          context: "purchase_form",
                        })
                      },
                    },
                  },
                  [_vm._v("\n        Already have an account?\n      ")]
                ),
                _vm._v(" "),
                _c("wa-text-field", {
                  ref: "accountEmail",
                  attrs: {
                    disabled: !!_vm.isPlacingOrder,
                    "is-processing": _vm.isCheckingEmailAvailability,
                    "is-valid":
                      _vm.$valid({ after: "payment", topics: ["email"] }) &&
                      !_vm.errors.hasError("email"),
                    "has-icon": "",
                    "icon-placement": "before",
                    "icon-style": "regular",
                    "icon-name": "faEnvelope",
                    "is-required": "",
                    label: "Email Address",
                    placeholder: "e.g. tchalla@wakanda.gov",
                    type: "email",
                  },
                  model: {
                    value: _vm.email,
                    callback: function ($$v) {
                      _vm.email = $$v
                    },
                    expression: "email",
                  },
                }),
                _vm._v(" "),
                _vm.$invalid({ after: "payment", topics: ["password"] })
                  ? _c("wa-message", {
                      attrs: {
                        content: "Password is required",
                        theme: "danger",
                        type: "flash",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$invalid({
                  after: "payment",
                  topics: ["passwordConfirmation"],
                })
                  ? _c("wa-message", {
                      attrs: {
                        content: "Password confirmation is required",
                        theme: "danger",
                        type: "flash",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$invalid({ after: "payment", topics: ["passwordsMatch"] })
                  ? _c("wa-message", {
                      attrs: {
                        content:
                          "Give it another try and make sure to enter the same phrase.",
                        title: "Those passwords do not match.",
                        theme: "danger",
                        type: "flash",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$invalid({ after: "payment", topics: ["passwordLength"] })
                  ? _c("wa-message", {
                      attrs: {
                        content:
                          "Give it another try and don't just add a bunch of 1's at the end.",
                        title: "This password is a bit too short.",
                        theme: "danger",
                        type: "flash",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row roomy align-between" }, [
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c("wa-text-field", {
                        attrs: {
                          disabled: !!_vm.isPlacingOrder,
                          valid:
                            _vm.$valid({
                              after: "payment",
                              topics: [
                                "password",
                                "passwordsMatch",
                                "passwordLength",
                              ],
                            }) && !_vm.errors.hasError("password"),
                          "has-icon": "",
                          "icon-style": "regular",
                          "icon-name": "faLock",
                          "is-required": "",
                          label: "Password",
                          tip: "Make it a good one!",
                          type: "password",
                        },
                        model: {
                          value: _vm.password,
                          callback: function ($$v) {
                            _vm.password = $$v
                          },
                          expression: "password",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c("wa-text-field", {
                        attrs: {
                          disabled: !!_vm.isPlacingOrder,
                          valid:
                            _vm.$valid({
                              after: "payment",
                              topics: [
                                "passwordConfirmation",
                                "passwordsMatch",
                                "passwordLength",
                              ],
                            }) && !_vm.errors.hasError("passwordConfirmation"),
                          "has-icon": "",
                          "icon-style": "regular",
                          "icon-name": "faLock",
                          "is-required": "",
                          label: "Confirm Password",
                          tip: "Make it match the good one!",
                          type: "password",
                        },
                        model: {
                          value: _vm.passwordConfirmation,
                          callback: function ($$v) {
                            _vm.passwordConfirmation = $$v
                          },
                          expression: "passwordConfirmation",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "margin-y-4xl" }),
      _vm._v(" "),
      _vm._l(_vm.errors.genericMessages, function (message, index) {
        return [
          _c(
            "wa-message",
            {
              key: index,
              attrs: {
                title: "Sorry, we couldn't process your order!",
                theme: "danger",
                type: "flash",
              },
            },
            [
              _c("p", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(message || "") +
                    " If the problem persists,\n        "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "mailto:hello@fontawesome.com?subject=I can't complete a payment, Font Awesome",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.supportLinkClicked("purchase_form_fail")
                      },
                    },
                  },
                  [_vm._v("let us know")]
                ),
                _vm._v("\n        and we'll get you unstuck.\n      "),
              ]),
            ]
          ),
        ]
      }),
      _vm._v(" "),
      _c("payment", {
        ref: "payment",
        attrs: {
          options: _vm.paymentOptions,
          "button-enabled": _vm.isReadyForPayment,
          "button-processing": !!_vm.isPlacingOrder,
          "is-processing": !!_vm.isPlacingOrder,
          "total-in-cents": _vm.totalCents,
          "item-label": _vm.billingDescription,
          label: "Font Awesome Pro",
          theme: _vm.theme,
        },
        on: {
          "button-clicked": _vm.handleButtonClicked,
          token: _vm.handlePaymentToken,
          error: _vm.handlePaymentError,
        },
        model: {
          value: _vm.selectedPaymentMethod,
          callback: function ($$v) {
            _vm.selectedPaymentMethod = $$v
          },
          expression: "selectedPaymentMethod",
        },
      }),
      _vm._v(" "),
      _c("wa-media", {
        model: {
          value: _vm.sizes,
          callback: function ($$v) {
            _vm.sizes = $$v
          },
          expression: "sizes",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }